var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresentationWill01 = function SvgPresentationWill01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 21.5q-1.048 0-1.774-.726A2.41 2.41 0 0 1 3.5 19v-2.884h3V2.5h14V19q0 1.048-.726 1.774A2.41 2.41 0 0 1 18 21.5zM18 20q.424 0 .712-.288A.97.97 0 0 0 19 19V4H8v12.116h9V19q0 .424.288.712.287.288.712.288M9.192 8.692v-1.5h8.616v1.5zm0 2.885v-1.5h8.616v1.5zM6 20h9.5v-2.385H5V19q0 .424.287.712Q5.576 20 6 20m0 0H5h10.5z"
  })));
};
export default SvgPresentationWill01;